module.exports = __webpack_public_path__ + "static/media/682.c971411a.webp";